import { useState } from "react"
import Swal from "sweetalert2";
import { useFetch } from "../../../common/hooks/useFetch.js"
import { createTaskKanbanService } from "../services/createTaskKanban.service.js";
import { deleteTaskKanbanService } from "../services/deleteTaskKanban.service.js";
import { importTasksKanbanService } from "../services/importTasksKanban.service.js";
import { updateTaskKanbanService } from "../services/updateTaskKanban.service.js";

const initialStateTask = {
  id: 0,
  title: '',
  description: '',
  date: '',
  status: 'pendiente',
  type: 'work'
}

export const useTaskCommand = (refresh) => {
  const fetchData = useFetch();
  const [task, setTask] = useState(initialStateTask)
  const [supportFile, setSupportFile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} })

  const handleChangeTask = ({ name, value }) => {
    setTask((prev) => ({
      ...prev,
      [name]: value
    }))
    setErrors(prev => ({
      ...prev,
      errors: {
        ...prev.errors,
        [name]: ''
      }
    }))
  }

  const setDefaultTask = (task) => {
    setTask(task ? task : initialStateTask)
    setSupportFile(null)
    setErrors({ hasErrors: false, errors: {} })
  }

  const createTask = async () => {
    try {
      setLoading(true)
      if (!validations(task)) return

      const response = await createTaskKanbanService(fetchData)(task)
      setTask(initialStateTask)
      refresh?.()
      Swal.fire({
        icon: 'success',
        title: 'Tarea creada',
        text: response.message,
        showConfirmButton: false,
        timer: 1500
      })

      return true
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const updateTask = async () => {
    try {
      setLoading(true)
      if (!validations(task)) return
      const response = await updateTaskKanbanService(fetchData)(task, supportFile)
      refresh?.()
      setTask(initialStateTask)
      setSupportFile(null)
      Swal.fire({
        icon: 'success',
        title: 'Tarea actualizada',
        text: response.message,
        showConfirmButton: false,
        timer: 1500
      })
      return true
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const deleteTask = async (id) => {
    try {
      setLoading(true)
      const response = await deleteTaskKanbanService(fetchData)(id)
      refresh?.()
      Swal.fire({
        icon: 'success',
        title: 'Tarea eliminada',
        text: response.message,
        showConfirmButton: false,
        timer: 1500
      })
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
    }
  }

  const importTasks = async (file) => {
    try {
      setLoading(true)
      const response = await importTasksKanbanService(fetchData)(file)
      refresh?.()
      Swal.fire({
        icon: 'success',
        title: 'Tareas importadas',
        text: response.message,
        showConfirmButton: false,
        timer: 1500
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message
      })
    } finally {
      setLoading(false)
    }
  }

  const validations = (task) => {
    const newErrors = {}

    if (!task.title) {
      newErrors.title = 'El título es requerido'
    }

    if (!task.description) {
      newErrors.description = 'La descripción es requerida'
    }

    if (!task.date) {
      newErrors.date = 'La fecha es requerida'
    }

    if (!task.type) {
      newErrors.type = 'El tipo es requerido'
    }

    if (!task.status) {
      newErrors.status = 'El estatus es requerido'
    }

    if (task.status === 'completada' && !task.supportDocument && !supportFile) {
      newErrors.supportDocument = 'Debe adjuntar un documento de soporte para marcar como completada'
    }

    if (task.type === 'training' && task.status === 'completada') {
      if (!task.numberTrainees) {
        newErrors.numberTrainees = 'El número de capacitados es requerido'
      }

      if (!task.peopleOrganization) {
        newErrors.peopleOrganization = 'El número de personas de la organización es requerido'
      }
    }

    const hasErrors = Object.keys(newErrors).length > 0
    setErrors({ hasErrors, errors: newErrors })
    return !hasErrors
  }

  return {
    task,
    loading,
    errors,
    supportFile,
    setSupportFile,
    handleChangeTask,
    setDefaultTask,
    createTask,
    updateTask,
    importTasks,
    deleteTask
  }
}
